<template>
  <path
    d="M12.5 8.00018C9.85 8.00018 7.45 8.99018 5.6 10.6002L3.71 8.71018C3.08 8.08018 2 8.52018 2 9.41018V15.0002C2 15.5502 2.45 16.0002 3 16.0002H8.59C9.48 16.0002 9.93 14.9202 9.3 14.2902L7.39 12.3802C8.78 11.2202 10.55 10.5002 12.51 10.5002C15.67 10.5002 18.4 12.3402 19.7 15.0002C19.97 15.5602 20.61 15.8402 21.2 15.6402C21.91 15.4102 22.27 14.6002 21.95 13.9202C20.23 10.4202 16.65 8.00018 12.5 8.00018Z"
  />
</template>
